import { useEffect } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import HowItWorks from "@/components/HowItWorks";
import UseCases from "@/components/UseCases";
import Calculator from "@/components/Calculator";
import Testimonials from "@/components/Testimonials";
import Pricing from "@/components/Pricing";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

export default function Home() {
  useEffect(() => {
    document.title = "NextVisit — Turn every visit into the next one | bookyournextvisit.com";
  }, []);

  return (
    <main className="bg-[#FAF7F0] text-[#252525]">
      <Nav />
      <Hero />
      <Features />
      <HowItWorks />
      <UseCases />
      <Calculator />
      <Testimonials />
      <Pricing />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
}
